
// This file is no longer needed since we're using snake_case directly
// All types are now defined in src/types/technique.ts
export * from '@/types/technique';

import type { Database } from '@/integrations/supabase/types';
import type { Technique, TechniquePosition, TechniqueType, TechniqueDifficulty } from '@/types/technique';

type TechniqueRow = Database['public']['Tables']['techniques']['Row'];

// Transform function to convert database row to frontend Technique type
export const transformTechniqueFromDB = (row: TechniqueRow): Technique => {
  // Helper function to validate and cast technique_position
  const validateTechniquePosition = (position: string | null): TechniquePosition => {
    if (!position) return 'standing'; // default value
    const validPositions: TechniquePosition[] = ['standing', 'top', 'bottom', 'transitional'];
    return validPositions.includes(position as TechniquePosition) ? position as TechniquePosition : 'standing';
  };

  // Helper function to validate and cast technique_type
  const validateTechniqueType = (type: string | null): TechniqueType => {
    if (!type) return 'other'; // default value
    const validTypes: TechniqueType[] = ['choke', 'joint_lock', 'sweep', 'takedown', 'control', 'escape', 'defensive', 'guard_passing', 'other'];
    return validTypes.includes(type as TechniqueType) ? type as TechniqueType : 'other';
  };

  // Helper function to validate and cast difficulty
  const validateDifficulty = (difficulty: string | null): TechniqueDifficulty => {
    if (!difficulty) return 'beginner'; // default value
    const validDifficulties: TechniqueDifficulty[] = ['beginner', 'intermediate', 'advanced'];
    return validDifficulties.includes(difficulty as TechniqueDifficulty) ? difficulty as TechniqueDifficulty : 'beginner';
  };

  return {
    id: row.id,
    name: row.name || '',
    slug: row.name?.toLowerCase().replace(/\s+/g, '-') || '',
    description: row.description || 'No description',
    position_id: row.position_id || '',
    technique_position: validateTechniquePosition(row.technique_position),
    technique_type: validateTechniqueType(row.technique_type),
    difficulty: validateDifficulty(row.difficulty),
    image_url: row.image_url || undefined,
    video_url: row.video_url || undefined,
    key_points: row.key_points || [],
    common_mistakes: row.common_mistakes || [],
    // personal_notes field doesn't exist in database row, so we omit it
    category: row.category || undefined,
    subcategory: row.subcategory || undefined,
    is_user_created: row.is_user_created || undefined,
    created_by_user_id: row.created_by_user_id || undefined,
    is_private: row.is_private || undefined,
    created_at: row.created_at || new Date().toISOString(),
    updated_at: row.updated_at || new Date().toISOString()
  };
};
